module.exports = __webpack_public_path__ + "static/img/14000304.f672d211.png";